import { Icon, Tag, Text } from "@growtherapy/sprout-ui";
import { faLightbulb } from "@fortawesome/pro-solid-svg-icons";
import { ModifiedToastAria, Toast } from "../../toasts";

export function PromptFollowUpToast({
  title,
  subtitle,
  ...toastAriaProps
}: {
  title: string;
  subtitle: React.ReactNode;
} & ModifiedToastAria) {
  return (
    <Toast {...toastAriaProps} alignment="top" className="sm:max-w-sm">
      <div className="flex gap-4 align-start flex-col">
        <div className="flex justify-between">
          <Tag
            use="lilac"
            className="flex flex-row justify-start items-center gap-2 px-2 py-1"
          >
            <Icon
              aria-hidden
              icon={faLightbulb}
              className="text-neutral-800 font-medium"
            />
            <Text variant="xs" className="text-neutral-800 font-medium">
              {title}
            </Text>
          </Tag>
        </div>
        <Text variant="sm">{subtitle}</Text>
      </div>
    </Toast>
  );
}
